export enum FeatureTypes {
  // Feature flags go here
  // None = 'NONE', // not a feature
  Optimize = 'PNDOPTIMIZE',
}
